import { Badge } from "@/components/ui/badge";
import type { BottlingEventStatus } from "@/lib/bottling-constants";

const statusVariantMap: Record<BottlingEventStatus, string> = {
  draft: "secondary",
  submitted: "default",
  confirmed: "pending",
  locked: "outline",
  completed: "completed",
};

export function BottlingStatusBadge({ status, className }: { status: BottlingEventStatus; className?: string }) {
  const label = status ? status.charAt(0).toUpperCase() + status.slice(1) : "—";
  return (
    <Badge variant={statusVariantMap[status] as any} className={className}>
      {label}
    </Badge>
  );
}
